import { COLOR_INTERFACE_TOKENS } from "./semantic/colors";
import type { ColorInterfaceToken } from "./semantic/colors";
import { COLOR_STATE_TOKENS } from "./state/colors";
import type { ColorStateToken } from "./state/colors";

export type ColorSemanticToken = ColorInterfaceToken | ColorStateToken;

export const COLOR_SEMANTIC_TOKENS: ColorSemanticToken[] = [
  ...COLOR_INTERFACE_TOKENS,
  ...COLOR_STATE_TOKENS
];

export { COLOR_INTERFACE_TOKENS } from "./semantic/colors";
export type { ColorInterfaceToken } from "./semantic/colors";
export { COLOR_STATE_TOKENS } from "./state/colors";
export type { ColorStateToken } from "./state/colors";
